import * as React from 'react';
import { z } from "zod";
import Typography from '@mui/material/Typography';
import { Container, Table, tableCellClasses, Button, Box, IconButton, Grid, Select, MenuItem, Alert, Snackbar, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // For auto-generating tables in PDF
import api, { fetchTechnicalRemovalTransfers, updateTechnicalRemovalTransfer, emailTechnicalRemovalTransferPdf, fetchCustomers, fetchVehicles, fetchSolutions, fetchUsers, fetchCustomerSupportRemovalTransfer } from "../services/ApiService";
import dayjs from 'dayjs'; // Install with npm: npm install dayjs
import BulkUpload from '../components/BulkUploadOperation';
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import DataTable from '../components/DataTable';
import { FormModal, RHFTextField, RHFSelect } from "../components/form";

const addSchema = z.object({
  completion_date: z.string().min(1, "Required"),
  status: z.string().min(1, "Required"),
  remarks: z.string().optional(),
  resource_name: z.string().optional(),
});

const editSchema = z.object({
  completion_date: z.string().min(1, "Required"),
  resource_name: z.string().min(1, "Required"),
});

export function TechnicalRemovalTransfer() {
      const [sendingEmailId, setSendingEmailId] = React.useState(null);
  const [selectedCustomerSupport, setSelectedCustomerSupport] = React.useState(null);
    const [csModalOpen, setCSModalOpen] = React.useState(false);
  const handleSendEmail = async (saleId) => {
        setSendingEmailId(saleId);

        try {
            await emailTechnicalRemovalTransferPdf(saleId, {});
            alert("Email sent successfully!");
        } catch (error) {
            console.error("Email error:", error);
            alert("Failed to send email.");
        }finally {
    setSendingEmailId(null);
  }
    };
    const handleStatusChange = async (saleId, newStatus, sale) => {
        const updatedSale = { ...sale, status: newStatus };

        try {
          await updateTechnicalRemovalTransfer(saleId, updatedSale);

          // Update state in frontend
          setEmployees((prevData) =>
            prevData.map((item) =>
              item.id === saleId ? { ...item, status: newStatus } : item
            )
          );

          showSnackbar('Status updated successfully', 'success');
        } catch (error) {
          console.error('Failed to update status:', error);
          showSnackbar('Failed to update status', 'error');
        }
      };
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };
const handleViewCustomerSupportDetail = async (saleId) => {
        try {
            const response = await fetchCustomerSupportRemovalTransfer(saleId);
            console.log(response.data);

            setSelectedCustomerSupport(response.data);
            setCSModalOpen(true);
        } catch (error) {
            console.error("Failed to fetch sale detail:", error);
        }
    };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [editModalOn, setEditModalOn] = React.useState(false);
  const handleEditOff = () => setEditModalOn(false)
  const handleEditOn = (row) => {
    console.log(row);
    console.log(typeof (row));
    setEditModalOn(true)
    setSelectedRow(row)
  }
  React.useEffect(() => {
    fetchHauliers();
    fetchTruck();
    fetchDeliveries();
    fetchDevices();
    loadUsers()
  }, []);
  const [haulierOptions, setHaulierOptions] = React.useState([]);
  const [truckOptions, setTruckOptions] = React.useState([]);
  const [devicesOptions, setDevicesOptions] = React.useState([]);
    const [usersOptions, setUsersOptions] = React.useState([]);

  const [users, setUsers] = React.useState([]);

  const loadUsers = async () => {
    try {
      const response = await fetchUsers();
      const deviceDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});

      setUsersOptions(deviceDict)
      setUsers(response.data);
    } catch (error) {
      console.error("Failed to fetch users", error);
    }
  };
  const fetchDeliveries = async () => {
    try {
      const response = await fetchTechnicalRemovalTransfers();
      console.log(response.data);

      setEmployees(response.data);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchHauliers = async () => {
    try {
      const response = await fetchCustomers();
      const allNames = response.data.map((employee) => employee.client_name);
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.client_name;
        return acc;
      }, {});
      setHaulierOptions(haulierDict)
      setHauliers(allNames);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchDevices = async () => {
    try {
      const response = await fetchSolutions();
      const allNames = response.data.map((employee) => employee.name);
      const deviceDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setDevicesOptions(deviceDict)
      setDevice(allNames);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchTruck = async () => {
    try {
      const response = await fetchVehicles();
      const allNames = response.data.map((employee) => employee.name);
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.registration_number;
        return acc;
      }, {});
      setTruckOptions(haulierDict)
      setTrucks(allNames);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const [device, setDevice] = React.useState([])

  const [haulier, setHauliers] = React.useState([])
  const [trucks, setTrucks] = React.useState([])

  const [employees, setEmployees] = React.useState([])
  const [modalOpen, setModalOpen] = React.useState(false);
  // Save employees to localStorage on update
  React.useEffect(() => {
    // localStorage.setItem('employees', JSON.stringify(employees));
  }, [employees]);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleExport = () => {
  const doc = new jsPDF('l', 'mm', 'a2'); // Landscape A2

  // Title
  doc.setFontSize(18);
  doc.text('Technical Removal/Transfer Report', 14, 16);

  // Match table headers
  const columns = [
    'Rem/Trans #',
    'CS Rem/Trans #',
    'Resource Name',
    'Completion Date',
    'Document',
    'Status',
  ];

  // Match row data
  const tableData = employees.map((row) => [
    row.id,
    row.customer_support_removal_transfer || '',
    usersOptions[row.resource_name] || '',
    formatDatetimeLocal(row.completion_date),
    row.document_url ? "Available" : "Not Available",
    row.status || '',
  ]);

  // Generate table
  doc.autoTable({
    head: [columns],
    body: tableData,
    startY: 30,
    styles: {
      fontSize: 9,
      cellPadding: 2.5,
    },
    columnStyles: {
      0: { cellWidth: 30 },  // Rem/Trans #
      1: { cellWidth: 40 },  // CS Rem/Trans #
      2: { cellWidth: 40 },  // Resource Name
      3: { cellWidth: 40 },  // Completion Date
      4: { cellWidth: 40 },  // Document
      5: { cellWidth: 30 },  // Status
    },
    theme: 'grid',
    didDrawPage: () => {
      doc.setFontSize(18);
      doc.text('CTechnical Removal/Transfer Report', 14, 16);
    },
  });

  doc.save('Technical_Removal_Transfer_Report.pdf');
};

  const EmployeeModal = ({ open, handleClose }) => {
    const [addImageFile, setAddImageFile] = React.useState(null);

    const userOptions = users.reduce((acc, u) => ({ ...acc, [u.id]: u.name || u.username }), {});

    return (
      <FormModal
        open={open}
        onClose={handleClose}
        title="Attach Device"
        schema={addSchema}
        defaultValues={{ completion_date: "", status: "", remarks: "", resource_name: "" }}
        submitLabel="Add"
        width={400}
        onSubmit={async (data) => {
          const fd = new FormData();
          Object.entries(data).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== "") fd.append(k, v); });
          fd.set("completion_date", dayjs(data.completion_date).format("YYYY-MM-DDTHH:mm:ss"));
          if (addImageFile) fd.append("image", addImageFile);
          try {
            await api.post("/technical-removal-transfer/", fd);
            showSnackbar("Haulier added successfully", "success");
            fetchDeliveries();
          } catch (err) {
            showSnackbar("Failed to add", "error");
            throw err;
          }
        }}
      >
        {({ control }) => (
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <RHFTextField
                control={control}
                name="completion_date"
                label="Completion Date"
                type="datetime-local"
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <RHFTextField control={control} name="status" label="Status" required />
            </Grid>
            <Grid item xs={12}>
              <RHFTextField control={control} name="remarks" label="Remarks" />
            </Grid>
            <Grid item xs={12}>
              <RHFSelect control={control} name="resource_name" label="Resource Name" options={userOptions} />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 500 }}>Image (optional)</Typography>
                <input type="file" accept="image/*" style={{ width: "100%" }} onChange={(e) => setAddImageFile(e.target.files?.[0] ?? null)} />
              </Box>
            </Grid>
          </Grid>
        )}
      </FormModal>
    );
  };


  function getBase64Image(imgPath) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgPath; // Ensure this path points to your public folder image

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataUrl = canvas.toDataURL(); // This will give you the base64 string
        resolve(dataUrl); // Return the complete base64 string (including header)
      };

      img.onerror = reject;
    });
  }

  const handleExportInvoice = (record) => {
    const doc = new jsPDF();

    // Create a blue strip at the top with the word 'Invoice'
    doc.setFillColor(0, 123, 255); // Set blue color for the strip (RGB)
    doc.rect(0, 0, 210, 20, 'F'); // Create a filled rectangle (top strip)

    // Add 'Invoice' text on the blue strip at the top, aligned left
    doc.setFontSize(24); // Increase font size
    doc.setFont('helvetica', 'bold'); // Set font to bold
    doc.setTextColor(255, 255, 255); // White text color
    doc.text('Invoice', 14, 14); // Left-aligned text (positioned at 14, 14)

    // Add Logo Image to PDF (start after the top strip)
    getBase64Image('/logo2.png').then((base64) => {
      // Add the image at the top (position at x=14, y=25, just after the blue strip)
      doc.addImage(base64, 'PNG', 14, 25, 50, 20); // Adjust width and height as needed
      let yPosition = 55; // Starting Y position for data below the logo

      // Add Invoice Date and To row
      doc.setFontSize(12); // Adjust size for the row text
      doc.setFont('helvetica', 'normal'); // Set font to normal
      doc.setTextColor(0, 0, 0); // Black text color

      // Invoice Date and To (with space in between)
      doc.text('Invoice Date:', 14, yPosition); // Label for Invoice Date
      doc.text(record.date, 40, yPosition); // Value of Invoice Date

      // Add space and then 'To' label
      doc.text('To:', 140, yPosition); // Label for To
      doc.text(record.haulier, 150, yPosition); // Value for To (Haulier)

      // Increase Y position for the next field after this row
      yPosition += 10;

      // Key-Value style (starting from the next line after the table)
      const fieldNames = [
        'Time', 'Truck', 'Expiry Date', 'Remarks'
      ];

      const fieldValues = [
        record.time, record.vehicle, record.expiryDate, record.remarks
      ];

      // Loop through the fields and print them as key-value pairs
      for (let i = 0; i < fieldNames.length; i++) {
        doc.setFontSize(12); // Adjusted size for field values
        doc.text(`${fieldNames[i]}:`, 14, yPosition); // Field name (Key)
        doc.text(fieldValues[i], 70, yPosition); // Field value
        yPosition += 10; // Increase Y position for the next field
      }

      // Table for Device ID and Cost
      doc.setFontSize(12);
      const tableStartY = yPosition; // Save the starting Y position for the table
      const cellHeight = 10; // Height for each table row

      // Table headers
      doc.setFont('helvetica', 'bold');
      doc.text('Device ID', 14, tableStartY);
      // Draw horizontal line under headers
      doc.line(14, tableStartY + 1, 190, tableStartY + 1); // Horizontal line below the headers

      // Table content
      doc.setFont('helvetica', 'normal');
      doc.text(record.device, 14, tableStartY + cellHeight);

      // Draw horizontal line under the table content
      doc.line(14, tableStartY + cellHeight + 1, 190, tableStartY + cellHeight + 1); // Line under the values

      // Table content
      doc.setFont('helvetica', 'normal');
      doc.text("Subtotal", 14, tableStartY + 2 * cellHeight);

      // Draw horizontal line under the table content
      doc.line(14, tableStartY + 2 * cellHeight + 1, 190, tableStartY + 2 * cellHeight + 1); // Line under the values


      // Increase Y position for the next section after the table
      yPosition = tableStartY + 2 * cellHeight; // Update yPosition after table

      // Create a blue strip at the bottom with the word 'Invoice'
      doc.setFillColor(0, 123, 255); // Set blue color for the strip (RGB)
      doc.rect(0, 285, 210, 20, 'F'); // Create a filled rectangle (top strip)
      // Add 'Invoice' text on the blue strip at the bottom, aligned left
      doc.setFontSize(12); // Increase font size
      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setTextColor(255, 255, 255); // White text color
      doc.text('This is a computer-generated invoice. It does not require any signature.', 33, 293); // Left-aligned text (positioned at 14, 293)

      // Update the record's generated status
      // Assuming you have a state or method to update the record, for example:
      record.generated = true; // Update generated flag here

      // Optionally update the state in your parent component if needed
      // setRecord(updatedRecords); // Assuming setRecord is the state setter function

      // Save the document
      doc.save('Device_Report.pdf');
    }).catch((err) => {
      console.error('Error loading image:', err);
    });
  };


  const EditOperationModal = ({ open, handleClose, selectedRow }) => {
    const [editImageFile, setEditImageFile] = React.useState(null);

    const userOptions = users.reduce((acc, u) => ({ ...acc, [u.id]: u.name || u.username }), {});

    const editDefaultValues = {
      completion_date: formatDatetimeLocal(selectedRow?.completion_date) ?? "",
      resource_name: selectedRow?.resource_name ? String(selectedRow.resource_name) : "",
    };

    return (
      <FormModal
        open={open}
        onClose={handleClose}
        title="Edit Operation"
        schema={editSchema}
        defaultValues={editDefaultValues}
        submitLabel="Update"
        width={400}
        onSubmit={async (data) => {
          const fd = new FormData();
          Object.entries(data).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== "") fd.append(k, v); });
          if (editImageFile) fd.append("image", editImageFile);
          try {
            await updateTechnicalRemovalTransfer(selectedRow.id, fd);
            showSnackbar("Updated successfully", "success");
            fetchDeliveries();
          } catch (err) {
            showSnackbar("Failed to update", "error");
            throw err;
          }
        }}
      >
        {({ control }) => (
          <>
            <Box sx={{ mx: -3, px: 3, py: 1, mb: 2, mt: -3, bgcolor: "action.hover", borderBottom: "1px solid", borderColor: "divider", display: "flex", gap: 3, flexWrap: "wrap" }}>
              <Typography variant="body2">
                Updated At: {selectedRow?.updated_at?.slice(0, 19).replace("T", " ")}
              </Typography>
              <Typography variant="caption" sx={{ display: "block" }}>
                Created At: {selectedRow?.created_at?.slice(0, 19).replace("T", " ")}
              </Typography>
            </Box>
            <Grid container spacing={2.5}>
              <Grid item xs={12}>
                <RHFTextField
                  control={control}
                  name="completion_date"
                  label="Completion Date"
                  type="datetime-local"
                  required
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <RHFSelect control={control} name="resource_name" label="Resource Name" options={userOptions} required />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 500 }}>Image (optional)</Typography>
                  <input type="file" accept="image/*" style={{ width: "100%" }} onChange={(e) => setEditImageFile(e.target.files?.[0] ?? null)} />
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      </FormModal>
    );
  };

  function formatDatetimeLocal(iso) {
  if (!iso) return "";
  const dt = new Date(iso);
  return new Date(dt.getTime() - dt.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);
}
  return (
    <Container maxWidth="xl" sx={{ m: 2 }}>
      <EmployeeModal
        open={modalOpen}
        handleClose={handleClose}
      />
      {editModalOn && selectedRow && (
        <EditOperationModal
          selectedRow={selectedRow}
          open={editModalOn}
          handleClose={handleEditOff}
        />
      )}
      <DataTable
        title="Technical Removal/Transfer List"
        columns={[
          { key: 'id', label: 'Rem/Trans #' },
          { key: 'customer_support_removal_transfer', label: 'CS Rem/Trans #', render: (row) => (
            <span onClick={() => handleViewCustomerSupportDetail(row.customer_support_removal_transfer)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}>{row.customer_support_removal_transfer}</span>
          )},
          { key: 'resource_name', label: 'Resource Name', render: (row) => usersOptions[row.resource_name] },
          { key: 'completion_date', label: 'Completion Date', render: (row) => formatDatetimeLocal(row.completion_date) },
          { key: 'document_url', label: 'Document', render: (row) => row.document_url ? (
            <a href={`https://crm-backend.monit.tech/${row.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a>
          ) : <span style={{ color: '#999' }}>Not Available</span> },
        ]}
        rows={employees}
        toolbarActions={<Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>}
        renderActions={(row) => (
          <Box display="flex" gap="6px">
            <IconButton color="primary" size="small" onClick={() => handleSendEmail(row.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sendingEmailId === row.id}>
              {sendingEmailId === row.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
            </IconButton>
            <IconButton color="secondary" size="small" onClick={() => handleEditOn(row)} sx={{ padding: '6px' }}><EditIcon /></IconButton>
            <Select fullWidth value={row.status} onChange={(e) => handleStatusChange(row.id, e.target.value, row)} size="small" sx={{ ml: 1, minWidth: 100 }}>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Complete">Complete</MenuItem>
            </Select>
          </Box>
        )}
      />
      <Dialog open={csModalOpen} onClose={() => setCSModalOpen(false)} maxWidth="sm" fullWidth>
                            <DialogTitle>Customer Support Details</DialogTitle>
                            <DialogContent>
                                {selectedCustomerSupport ? (
                                    <Box>
                                        <Typography variant="body1"><strong>Location:</strong> {selectedCustomerSupport.location}</Typography>
                                    </Box>
                                ) : (
                                    <Typography variant="body2">Loading...</Typography>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setCSModalOpen(false)} color="primary">Close</Button>
                            </DialogActions>
                        </Dialog>
      <Snackbar
              open={snackbar.open}
              autoHideDuration={4000}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                {snackbar.message}
              </Alert>
            </Snackbar>
    </Container>
  );
}
